import React from 'react';
import { User } from "styled-icons/fa-solid";

import { getUserDetails } from "../data/data";
import AppContent from '../shared/AppContent';
import { AuthContext } from "../../authContext";
import Definition from '../shared/Definition';
import getFileSizeDescription from "../shared/utilities/getFileSizeDescription";
import LicenceContainer from "./LicenceContainer";
import Loading from "../shared/Loading";
import PageHeading from '../shared/PageHeading';
import WebLink from "../shared/WebLink";

import { passwordResetUrl, clientAreaUrl, theme } from "../../configuration";
import {getQuota} from "../data/dataCIMToolkit";

class Account extends React.Component {
  static contextType = AuthContext;
  state = {
    isLoading: true,
    userDetails: {
      users: [],
      licences: [],
      quotaUsed: {}
    }
  };
  componentDidMount = async () => {
    if (!this.context.isLoggedIn) {
      console.log("User login has expired, will redirect to homepage")
      this.context.navigate('/');
    }
    else {
      if (this.context.userDetails.token !== "") {
        const userDetails = await getUserDetails(this.context.userDetails.token);

        for (let i = 0; i < userDetails.data.licences.length; i++) {
          userDetails.data.licences[i].isVisible = false;
        }
        const quotaUsed = await getQuota(this.context.userDetails.token);
        this.setState({userDetails: userDetails.data, isLoading: false, quotaUsed: quotaUsed.data});
      }
    }
  };
  getUserIconStyle = isCurrentUser => {
    return {
      color: isCurrentUser ? theme.colours.adminUserIcon : theme.colours.standardUserIcon
    }
  };
  toggleLicence = async id => {
    let newUserDetails = this.state.userDetails;
    for (let i = 0; i < newUserDetails.licences.length; i++) {
      if (newUserDetails.licences[i].id === id)
        newUserDetails.licences[i].isVisible = !newUserDetails.licences[i].isVisible;
    }
    await this.setState({userDetails: newUserDetails});
  };
  render() {
    if (!this.context.isLoggedIn) {
      this.context.navigate('/');
      return "";
    }
    if (this.state.isLoading)
      return (<Loading />);
    else {
      return (
        <AppContent>
          <PageHeading>Account details</PageHeading>

          <h4>Overview</h4>
          {
            this.state.userDetails.user.accountName !== ""
            &&
            <div>
              <Definition>Organization</Definition>
              <div>
                {this.state.userDetails.user.accountName}<br/>
                {this.state.userDetails.user.city}, {this.state.userDetails.user.countryCode}<br />
              </div>
            </div>
          }

          <Definition>Username</Definition>
          {this.state.userDetails.email} <WebLink href={passwordResetUrl} target="_blank" inline small>Reset password</WebLink>

          <h4>Team</h4>
          <div style={{marginTop: "7px"}}>
            {
              this.state.userDetails.users.map(user => {
                return (
                  <div key={`${user.id}-${user.contactID}`}>
                    <User size={14} style={this.getUserIconStyle(user.isCurrentUser)}/> {user.firstname} {user.lastname} {user.isCurrentUser && " (You)"} {user.contactID === -1 && " (Team Admin)"}
                  </div>
                );
              })
            }
          </div>

          <h4>Subscriptions</h4>
          <div>
            {
              this.state.userDetails.licences.map(licence => {
                if (licence.domainstatus === 'Active') {
                  return (
                    <LicenceContainer
                      toggleLicence={this.toggleLicence}
                      key={licence.id}
                      licence={licence}
                    />
                  );
                }
                return null;
              })
            }
          </div>
          <div>
            {
              this.state.userDetails.licences.map(licence => {
                if (licence.domainstatus !== 'Active') {
                  return (
                    <LicenceContainer toggleLicence={this.toggleLicence} key={licence.id} licence={licence} />
                  );
                }
                return null;
              })
            }
          </div>

          {
            this.state.quotaUsed.quota > 0
            &&
            <div>
              <Definition>Cloud storage quota used</Definition>
              <p>Quota used: {getFileSizeDescription(this.state.quotaUsed.quotaUsed)} / {getFileSizeDescription(this.state.quotaUsed.quota)}</p>
            </div>
          }
          <div style={{marginTop:"25px", padding:"10px 10px 10px 10px", borderTop:"1px solid #cdcdcd", textAlign:"center"}}>
            <WebLink href={clientAreaUrl} target="_blank" small>Manage my details in the client area</WebLink>
          </div>
        </AppContent>
      );
    }
  }
}

export default Account;
